import { Col, Row, message } from 'antd'
import styled from 'styled-components'
import { icons } from '@/shahrzad-assets/shared-asstes/icons'
import { fontSize, fontsWeight } from '@/shahrzad-assets/shared-constants/fonts'
import { dimens } from '@/shahrzad-assets/shared-constants/dimens'
import CustomButton from '@/shahrzad-assets/shared_components/CustomButton'
import { buttonTypes } from '@/shahrzad-assets/shared-constants/buttonTypes'
import copyTextToClipboard from '@/shahrzad-assets/shared-utils/copyTextToClipboard'
import useInviteFriends from '@/hooks/useInviteFriends'
import { useContext, useEffect } from 'react'
import { FullScreenModalContext } from '@/shahrzad-assets/shared_components/FullScreenModalContext'
import { Link } from 'react-router-dom'
import { sharedPathes } from '@/shahrzad-assets/shared-routing/pathe'
import ShareInSocial from '@/shahrzad-assets/shared_components/ShareInSocial'
import { PaymentSection } from '@/shahrzad-assets/shared_components/style-components/Styles'
import PageTitle from '@/shahrzad-assets/shared_components/PageTitle'
import ContentLayout from '@/shahrzad-assets/shared_components/ContentLayout'

const InviteFriends = () => {
  const { fetchInviteCode, inviteCodeLoading, inviteCode } = useInviteFriends()
  const modalCtx = useContext(FullScreenModalContext)

  useEffect(() => {
    fetchInviteCode()
  }, [])

  const handleInviteCode = () => {
    modalCtx?.hide()
  }

  const copyToClipboard = () => {
    const textToCopy = inviteCode?.referers?.[0]?.value

    if (textToCopy !== undefined) {
      copyTextToClipboard(textToCopy)
        .then(() => {
          message.success('متن با موفقیت کپی شد')
        })
        .catch(() => {
          message.error('خطا در کپی متن')
        })
    } else {
      message.error('هیچ متنی برای کپی وجود ندارد')
    }
  }

  return (
    <>
      <PageTitle title='دعوت از دوستان' />
      <ContentLayout>
        <Image src={icons.INVITE_FRIENDS}></Image>
        <Content>
          <Title>
            دریافت درصدی از سود فروش نوماند با اضافه کردن دوستان‌تان
          </Title>

          <Desc>
            لینک یا کد دعوت منحصر به فرد خود را برای دوستان‌تان ارسال کنید، با
            دعوت موفق می‌توانید مقداری از سود فروش نوماند دوستان‌تان را دریافت
            کنید.
          </Desc>
        </Content>

        <CodeWrapper justify={'center'}>
          <InviteCode>
            <img src={icons.COPY_BUTTON} onClick={copyToClipboard} />
            <CodeInput>
              <div>
                <p>{inviteCode && inviteCode?.referers[0]?.value}</p>
              </div>
            </CodeInput>
          </InviteCode>
        </CodeWrapper>
      </ContentLayout>
      <Footer className='fit-width'>
        {inviteCode && (
          <ShareInSocial
            text='بعد از دانلود و نصب شهرزاد، با کد معرف من وارد اپلیکیشن شوید'
            url={inviteCode?.referers[0]?.value}
            title='اشتراک‌گذاری کد معرف'
          >
            <CustomButton
              styletype={buttonTypes.PRIMARY_FILL}
              height={dimens.BUTTON_LARGE_HEGHIT}
              width='100%'
            >
              ارسال دعوت نامه
            </CustomButton>
          </ShareInSocial>
        )}

        <Link to={sharedPathes.REFERRAL_CODE}>
          <CustomButton
            styletype={buttonTypes.NO_STYLE}
            height={dimens.BUTTON_LARGE_HEGHIT}
            onClick={handleInviteCode}
            width='100%'
          >
            <EnterCode> وارد کردن کد معرف</EnterCode>
          </CustomButton>
        </Link>
      </Footer>
    </>
  )
}

export default InviteFriends

const Image = styled.img`
  width: 100%;
`

const Content = styled.div`
  margin: ${dimens.SPACING_M} 0;
`

const Title = styled.h3`
  font-size: ${fontSize.NORMAL};
  font-weight: ${fontsWeight.BOLD};
  line-height: ${dimens.LINE_HEIGHT_MEDIUM};
`

const InviteCode = styled.div`
  display: flex;
  flex-direction: row-reverse;
  padding: ${dimens.SPACING_XS};
  border-radius: ${dimens.BORDER_RADIUS_8};
  background-color: #f4f4f4;
  gap: ${dimens.SPACING_S};
`

const CodeInput = styled.div`
  display: flex;
  justify-content: center;
  align-self: center;
`

const Footer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${dimens.SPACING_M};
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  width: 100%;
  padding: ${dimens.SPACING_XL} ${dimens.SPACING_M};
  ${PaymentSection}
`

const Desc = styled.p`
  line-height: ${dimens.LINE_HEIGHT_MEDIUM};
  margin-top: ${dimens.SPACING_XS};
`
const CodeWrapper = styled(Row)`
  margin-bottom: ${dimens.SPACING_M};
`
const EnterCode = styled.p`
  font-size: ${fontSize.MEDIUM};
  font-weight: ${fontsWeight.MEDIUM};
`
